import { css } from "react-emotion";

export const container = css `
  padding: 1em 5em 5em 2em;
  background: white;
  position: relative;
`;

export const result = css `
  * {
    font-family: 'Quicksand', 'M PLUS Rounded 1c';
    margin-bottom: 1em;
  }

  ul {
    margin-left: 3em;
  }
`;